import {
  CameraAltTwoTone,
  CodeTwoTone,
  ColorLensTwoTone,
  ConfirmationNumberTwoTone,
  DescriptionTwoTone,
  DesignServicesTwoTone,
  DeveloperModeTwoTone,
  DevicesOtherTwoTone,
  EmojiObjectsTwoTone,
  FormatAlignCenterTwoTone,
  FormatColorFillTwoTone,
  FormatShapesTwoTone,
  GestureTwoTone,
  HomeWorkTwoTone,
  InsertChartTwoTone,
  LayersTwoTone,
  LocalOfferTwoTone,
  LyricsTwoTone,
  MailTwoTone,
  MicTwoTone,
  PageviewTwoTone,
  PermMediaTwoTone,
  PrintTwoTone,
  PsychologyTwoTone,
  RememberMeTwoTone,
  ScreenShareTwoTone,
  ShoppingBagTwoTone,
  ShoppingBasketTwoTone,
  SmartToyTwoTone,
  StorefrontTwoTone,
  TerminalTwoTone,
  ThumbUpTwoTone,
  TrendingUpTwoTone,
  VideocamTwoTone,
  VideogameAssetTwoTone,
  WebTwoTone,
} from '@mui/icons-material';
import { TFunction } from '@sortlist-frontend/translation/ssr';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const getExpertiseDetails = (t: TFunction, expertise: string, size?: number) => {
  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (expertise) {
    case 'b7bc7605-0349-4f1f-afd2-0fca89e12f00':
      return {
        description: t('common:expertises.digitalMarketing.description'),
        icon: <ScreenShareTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'f020ed06-3687-4e03-bbc7-71411158e34f':
      return {
        description: t('common:expertises.branding.description'),
        icon: <FormatShapesTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '22222a08-cbe3-4766-900e-158bb628378c':
      return {
        description: t('common:expertises.uxAgency.description'),
        icon: <DevicesOtherTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '7220fad8-5515-41bb-b233-888fb7981bbf':
      return {
        description: t('common:expertises.contentMarketing.description'),
        icon: <DescriptionTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'f33466d3-cd20-46a3-bb45-6faf1637eaf4':
      return {
        description: t('common:expertises.ecommerce.description'),
        icon: <ShoppingBasketTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '07c1c6e8-ae97-438c-997c-78be9dc7b0bd':
      return {
        description: t('common:expertises.webDevelopment.description'),
        icon: <CodeTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '3d4efe30-da29-4c41-bd60-c8f0cbe87787':
      return {
        description: t('common:expertises.webDesign.description'),
        icon: <WebTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'ee45a92a-5bbf-4b18-ba54-6db45e12b289':
      return {
        description: t('common:expertises.design.description'),
        icon: <FormatColorFillTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'd9022750-9997-4bfa-998e-270cde40edc7':
      return {
        description: t('common:expertises.animation.description'),
        icon: <GestureTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'd2fe8b73-0878-4128-abcd-5c27d9b7ab6f':
      return {
        description: t('common:expertises.video.description'),
        icon: <VideocamTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '7a413945-0c24-4496-b353-86f05dc7aec5':
      return {
        description: t('common:expertises.appDevelopment.description'),
        icon: <DeveloperModeTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'f351cdfe-5719-446a-8c0a-3691f8e4751e':
      return {
        description: t('common:expertises.copywriting.description'),
        icon: <FormatAlignCenterTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '8cc5dee8-37be-490c-95e6-dda5b511344c':
      return {
        description: t('common:expertises.socialMedia.description'),
        icon: <ThumbUpTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '45a0a302-60e3-4583-a81a-e241231347cf':
      return {
        description: t('common:expertises.gaming.description'),
        icon: <VideogameAssetTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'b5016377-6b83-43e8-969a-830d7b93ae82':
      return {
        description: t('common:expertises.event.description'),
        icon: <ConfirmationNumberTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'fc6c079d-f9c9-4adb-9d12-44143b51153d':
      return {
        description: t('common:expertises.seo.description'),
        icon: <PageviewTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '49747e50-ea56-45b9-94f4-b14d6064ee05':
      return {
        description: t('common:expertises.mediaPlanning.description'),
        icon: <PermMediaTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'fff29fc8-84b5-40ad-896e-ba430404d794':
      return {
        description: t('common:expertises.advertising.description'),
        icon: <LocalOfferTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'c878b61a-93b4-403e-a8f5-b0cbc9c7bbf3':
      return {
        description: t('common:expertises.emailMarketing.description'),
        icon: <MailTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '043dce40-c094-46ed-8781-4537cc9ba3f4':
      return {
        description: t('common:expertises.onlineAd.description'),
        icon: <StorefrontTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '69f12397-8c31-4ab3-b4fd-51417636d80b':
      return {
        description: t('common:expertises.3dDesign.description'),
        icon: <LayersTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '7e6fa29d-26c1-4d7c-98f2-4bd029463f7d':
      return {
        description: t('common:expertises.publicRelations.description'),
        icon: <MicTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '4cf96f3a-b460-4912-ae9e-0b3f8c3ccde1':
      return {
        description: t('common:expertises.photography.description'),
        icon: <CameraAltTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '81df76af-708d-4b89-a9b5-4aa8136e2d72':
      return {
        description: t('common:expertises.webAnalytics.description'),
        icon: <TrendingUpTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'fd52bd23-fabe-45e9-a071-6107c309fcbb':
      return {
        description: t('common:expertises.innovation.description'),
        icon: <EmojiObjectsTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'b09505f3-cdf1-4f25-87c9-40ce842b7a57':
      return {
        description: t('common:expertises.dataConsulting.description'),
        icon: <InsertChartTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '1a978a70-30b2-4524-869a-e14c091d7186':
      return {
        description: t('common:expertises.artificialIntelligence.description'),
        icon: <SmartToyTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '1f373fa2-18dc-439d-b918-0530c192039e':
      return {
        description: t('common:expertises.audioProduction.description'),
        icon: <LyricsTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '23a03dde-1c6f-46f9-9058-65f11e3f4ad8':
      return {
        description: t('common:expertises.graphicIdentity.description'),
        icon: <ColorLensTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '91d2cdc6-bf0f-4885-9a12-7117fc2edc35':
      return {
        description: t('common:expertises.influencerMarketing.description'),
        icon: <RememberMeTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '5aaff53b-0bca-41c4-988c-b5d93d7eee5d':
      return {
        description: t('common:expertises.marketing.description'),
        icon: <ShoppingBagTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '43a9c81f-681c-4ecf-b55b-32628dfe8792':
      return {
        description: t('common:expertises.outdoorAdvertising.description'),
        icon: <HomeWorkTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'b0a38bb4-8569-4acf-af34-67592d6a4e30':
      return {
        description: t('common:expertises.print.description'),
        icon: <PrintTwoTone style={{ fontSize: size || 16 }} />,
      };
    case 'd9155346-92a9-4191-8936-4eb0f9ecda40':
      return {
        description: t('common:expertises.productManagement.description'),
        icon: <PsychologyTwoTone style={{ fontSize: size || 16 }} />,
      };
    case '592cdf2e-1b5d-4dcd-b3ac-4c5746f71745':
      return {
        description: t('common:expertises.softwareDevelopment.description'),
        icon: <TerminalTwoTone style={{ fontSize: size || 16 }} />,
      };
    default:
      return {
        icon: <DesignServicesTwoTone style={{ fontSize: size || 16 }} />,
      };
  }
};
